export const PROFILE = {
  name: "Michael J. Warden",
  company: "Warden Offshore Engineering",
  companyTag: "Private engineering consultancy",
  title: "Offshore Drilling Engineer",
  years: 26,
  location: "Leesburg, VA · Gulf of Mexico",
  tagline: "Twenty-six years keeping steel, pressure and people in balance — 200 miles from shore.",
  availability: "Currently on contract — Gulf of Mexico",
};

export const STATION = {
  label: "Current station",
  region: "Gulf of Mexico",
  status: "Ongoing project",
  coords: "N 27° 30' — W 90° 00'",
  role: "Principal Consultant · Warden Offshore Engineering",
  since: "2026",
  image: "/michael-rig.jpg",
};

export const CONTACT = {
  company: "Warden Offshore Engineering",
  email: "michaelwarden29@gmail.com",
  phone: "+1 (571) 690-9681",
  whatsapp: "+1 (781) 985-8552",
  address: ["Leesburg, Virginia", "United States"],
  linkedin: "",
  hours: "Reachable offshore · replies within 48 h",
  placeholderNote: "",
};

const CDN = "https://static.prod-images.emergentagent.com/jobs/0f908c0c-bcac-44fd-a292-a3e9799d832c/images/";

export const IMAGES = {
  hero: `${CDN}bd7206d47012747a62a1780c1eb2c2dcf1ace5ecb4127f7749f423d319ecb0b5.jpeg`,
  portrait: "/michael-warden.jpg",
  deck: "/michael-rig.jpg",
  rig: "/michael-deck.jpg",
  rigPortrait: `${CDN}68086a313480c4de7555307034f9348a518eab70611dc92eb98bdac625f8653a.jpeg`,
  drillFloor: `${CDN}bd47f64e71649104898fcad473d135273b96f50b1555e16a405ba1208fcfec6d.jpeg`,
  bop: `${CDN}48640631329083d60fbab971334b59bdcb6e7ca72f811d6321b2d4e72157c112.jpeg`,
  drillBits: `${CDN}765fc131a1982cedf9f9c33c214149291eee2ba025d4720036ac0d9affa158c9.jpeg`,
  topDrive: `${CDN}82a8d455649ed315aa2d7aecb2ab09b59142b7f82e18118a00fe84af0269e1c7.jpeg`,
  tools: `${CDN}960c2fef813118cf9d90f555f948724b8fb6414189d3d571492b8a94452da431.jpeg`,
  jackup: `${CDN}e81a4093681cfffe1f531644f7a32880d8a2d73df5f42e142a5540c545eb9068.jpeg`,
  mudPumps: `${CDN}3f4f8943103a9d9ab79957f1bad0f0c8e8be9e00f7cc17c98355a5ccfbc30861.jpeg`,
  controlRoom: `${CDN}99c88869597e6442bf7e501173e78f733a7b1f4aba0db7c9a3e8c0d009f4ae12.jpeg`,
};

export const STATS = [
  { value: "26", suffix: "yrs", label: "Offshore experience" },
  { value: "14", suffix: "", label: "Rigs & platforms" },
  { value: "0", suffix: "", label: "Lost-time incidents led" },
  { value: "4.1", suffix: "M", label: "Man-hours supervised" },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "The Rig",
    image: IMAGES.rig,
    caption: "Michael on the production deck — Gulf of Mexico",
    body: "A rig is a machine that lives in weather. It is never finished, never quiet, never forgiving. I learned to read it before I learned to run it — every vibration in the derrick, every change in mud returns, every man's face at shift change.",
  },
  {
    num: "02",
    title: "The Well",
    image: IMAGES.bop,
    caption: "18¾\" 15K subsea BOP stack on the moonpool skid",
    body: "Below the seabed there is pressure that wants out. My work is a conversation with that pressure: barriers, margins, kill sheets checked twice. Twenty-six years and I still walk the pit room before I trust a number on a screen.",
  },
  {
    num: "03",
    title: "The Crew",
    image: IMAGES.deck,
    caption: "Pipe-lay spread, back deck — crew briefing before the lift",
    body: "Steel does not go home at the end of a hitch. People do. Every decision I make on a drill floor is measured against one question — does every hand on this deck step onto the chopper in the same condition they arrived?",
  },
];

export const EXPERTISE = [
  {
    span: "md:col-span-2",
    code: "DRL",
    title: "Drilling Operations",
    image: IMAGES.drillFloor,
    body: "Deepwater and HPHT wells, managed-pressure drilling, directional programmes, bit and BHA optimisation across 14 assets.",
  },
  {
    span: "",
    code: "WCT",
    title: "Well Control",
    image: IMAGES.bop,
    body: "IWCF Level 4 Supervisor. Kick detection, shut-in procedures, kill operations.",
  },
  {
    span: "",
    code: "HSE",
    title: "HSE Leadership",
    image: IMAGES.tools,
    body: "Safety-case ownership, permit-to-work, incident investigation lead.",
  },
  {
    span: "md:col-span-2",
    code: "RIG",
    title: "Rig Systems & Maintenance",
    image: IMAGES.mudPumps,
    body: "Top drives, BOP stacks, mud systems, drawworks. Planned maintenance and campaign shutdown management for semi-subs and jack-ups.",
  },
  {
    span: "",
    code: "PLN",
    title: "Well Planning",
    image: IMAGES.controlRoom,
    body: "Casing design, cement programmes, AFE budgeting and rig-move logistics.",
  },
  {
    span: "",
    code: "CRW",
    title: "Crew Development",
    image: IMAGES.rigPortrait,
    body: "Trained 60+ roustabouts through to driller. Competency assurance programmes.",
  },
];

export const MACHINERY = [
  { id: "bop", name: "BOP Stack", spec: "18¾\" · 15,000 psi · 5 ram cavities", image: IMAGES.bop },
  { id: "topdrive", name: "Top Drive", spec: "1,000 t · 65,000 ft·lb torque", image: IMAGES.topDrive },
  { id: "bits", name: "PDC & Tricone Bits", spec: "8½\" – 26\" · IADC 437 – M433", image: IMAGES.drillBits },
  { id: "tongs", name: "Tongs, Slips & Elevators", spec: "Manual handling · 5½\" – 13⅜\"", image: IMAGES.tools },
  { id: "pumps", name: "Triplex Mud Pumps", spec: "3 × 2,200 hp · 7,500 psi", image: IMAGES.mudPumps },
  { id: "cabin", name: "Driller's Cabin", spec: "Cyberbase · MPD integrated", image: IMAGES.controlRoom },
];

export const TIMELINE = [
  {
    years: "2026 — Present",
    role: "Principal Consultant",
    company: "Warden Offshore Engineering",
    place: "Gulf of Mexico",
    note: "Ongoing project. Independent drilling and well-control consultancy for an operator in the deepwater Gulf.",
  },
  {
    years: "2019 — 2026",
    role: "Senior Drilling Superintendent",
    company: "North Basin Energy",
    place: "North Sea, UK",
    note: "Oversight of two semi-submersibles. Delivered 11 wells, 18% under AFE.",
  },
  {
    years: "2014 — 2019",
    role: "Rig Manager",
    company: "Meridian Offshore Drilling",
    place: "Gulf of Mexico",
    note: "Led a 140-person deepwater crew. Four consecutive years zero LTI.",
  },
  {
    years: "2010 — 2014",
    role: "Toolpusher",
    company: "Meridian Offshore Drilling",
    place: "West Africa",
    note: "HPHT campaign, 6 wells. Introduced digital tour-sheet reporting.",
  },
  {
    years: "2006 — 2010",
    role: "Driller",
    company: "Atlas Rig Services",
    place: "Norwegian Sector",
    note: "Managed-pressure drilling on jack-up fleet. IWCF Level 4 achieved.",
  },
  {
    years: "2000 — 2006",
    role: "Roustabout → Derrickman",
    company: "Atlas Rig Services",
    place: "Southern North Sea",
    note: "Where it started. Deck, derrick, mud pits and the first winter storm.",
  },
];

export const PROJECTS = [
  {
    id: "gulf",
    portrait: true,
    name: "Gulf of Mexico — Current",
    type: "Deepwater · Ongoing project · Warden Offshore Engineering",
    year: "2026",
    image: IMAGES.deck,
    body: "Current station. Independent consultancy covering well planning, well control and rig readiness for an active deepwater programme.",
  },
  {
    id: "borealis",
    name: "Borealis Deep",
    type: "Semi-submersible · 1,400 m water depth",
    year: "2023",
    image: IMAGES.hero,
    body: "Seven-well exploration campaign in harsh-environment waters. Zero well-control events, delivered 42 days ahead of schedule.",
  },
  {
    id: "meridian",
    name: "Meridian Titan",
    type: "Drillship · Gulf of Mexico",
    year: "2017",
    image: IMAGES.drillFloor,
    body: "HPHT development wells at 8,000 m TD. Introduced a dual-gradient MPD system now standard on the fleet.",
  },
  {
    id: "atlas",
    name: "Atlas Sentinel",
    type: "Jack-up · Norwegian Sector · 120 m",
    year: "2009",
    image: IMAGES.jackup,
    body: "Twelve development wells from a single jack-up location. First MPD deployment on the Atlas fleet.",
  },
];

export const CREDENTIALS = [
  "IWCF Well Control — Level 4 Supervisor (Combined Surface & Subsea)",
  "BOSIET / HUET / CA-EBS — Current",
  "NEBOSH International Certificate in Oil & Gas Operational Safety",
  "OPITO Offshore Installation Manager (OIM) Controlling Emergencies",
  "BSc (Hons) Petroleum Engineering — Robert Gordon University",
  "IADC WellSharp Drilling Operations — Supervisor",
];

export const MARQUEE_WORDS = [
  "26 Years Offshore",
  "Warden Offshore Engineering",
  "Gulf of Mexico",
  "Zero LTI",
  "Deepwater",
  "HPHT",
  "Well Control",
];

export const NAV = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Expertise", href: "#expertise" },
  { label: "Machinery", href: "#machinery" },
  { label: "Career", href: "#career" },
  { label: "Rigs", href: "#rigs" },
  { label: "Contact", href: "#contact" },
];
